import { formatDate, fullName } from '../../utils/getPostRole'

export const jobExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{ label: 'Name', render: p => fullName(p) },
	{ label: 'Mobile', render: p => p?.mobile || '' },
	{ label: 'Role', render: p => p?.jobRole || '' },
	{ label: 'Education', render: p => p?.education || '' },
	{ label: 'Skills', render: p => p?.jobSkill || '' },
	{ label: 'Experience', render: p => p?.jobExperience || '' },
	{ label: 'Salary Band', render: p => p?.jobSalaryBand || '' },
	{
		label: 'Preferred Location',
		render: p => p?.jobPreferredLocation || '',
	},
	{ label: 'Created Date', render: p => formatDate(p?.createdAt) },
]
